/** angular */
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
/** end angular */

@Pipe({
  name: 'bydGetBlobUrl',
})
export class BydGetBlobUrlPipe implements PipeTransform {
  /**
   * Creates an instance of BydGetBlobUrlPipe.
   *
   * @param sanitizer The DOM sanitizer
   */
  constructor(private sanitizer: DomSanitizer) {}

  /**
   * Returns an URL from a Blob file.
   *
   * @param blob The Blob to convert
   * @returns The Blob URL
   */
  public transform(blob: Blob): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(blob));
  }
}
